import type { IconData } from '@stacksjs/iconify-core'

export const sc1x1: IconData = {
  "body": "<path fill=\"#fff\" d=\"M0 0h512v512H0Z\"/><path fill=\"#d92223\" d=\"M0 512V0h512v170.7z\"/><path fill=\"#fcd955\" d=\"M0 512V0h341.3z\"/><path fill=\"#003d88\" d=\"M0 512V0h170.7z\"/><path fill=\"#007a39\" d=\"m0 512l512-170.7V512Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default sc1x1
